import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {SettingsPassOnLogService} from '../../../services/settings-pass-on-log.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'settings-pass-on-log-list',
    templateUrl: './settings-pass-on-log-list.component.html',
    styleUrls: ['./settings-pass-on-log-list.component.scss']
})
export class SettingsPassOnLogListComponent {

    constructor(
        public urlService: UrlService,
        public settingsPassOnLogService: SettingsPassOnLogService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.settingsPassOnLogService.corporations.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }

    toggleCheck(selectedItem): void {
        this.settingsPassOnLogService.emptyNotificationArrays();
        if (selectedItem.checked && this.settingsPassOnLogService.selectedItemData)
            this.settingsPassOnLogService.toggleDetailedView(null, false);
        else
            this.settingsPassOnLogService.toggleDetailedView(selectedItem, true);
    }

    showHint(e) {
        e.stopPropagation();
        const $td = $(e.target).closest('.table-hint-td');
        if ($td.hasClass('active'))
            $td.removeClass('active');
        else {
            $('.table-hint-td').removeClass('active');
            $td.addClass('active');
        }
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/settings-pass-on-log/settings-pass-on-log-list/settings-pass-on-log-list.component.ts